<template>
  <div class="categories-page">
    <div class="container">
      <div class="page-header">
        <h1>Shop by Category</h1>
        <p class="subtitle">Browse products by category</p>
      </div>

      <!-- Categories Grid -->
      <div v-if="categories.length > 0" class="categories-grid">
        <a
          v-for="category in categories"
          :key="category.id"
          :href="`/${category.slug}`"
          class="category-card"
        >
          <div class="category-info">
            <h3>{{ category.name }}</h3>
            <p class="category-stats">
              <span v-if="category.products_count">{{ category.products_count }} products</span>
              <span v-if="category.sub_categories_count"> • {{ category.sub_categories_count }} subcategories</span>
            </p>
          </div>
          <i class="fas fa-chevron-right arrow"></i>
        </a>
      </div>

      <!-- Empty State -->
      <div v-else class="empty-state">
        <i class="fas fa-folder-open"></i>
        <h2>No Categories Available</h2>
        <p>Check back later for new categories!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryList',
  props: {
    categories: {
      type: Array,
      required: true
    }
  }
}
</script>
